<template>
  <ChartCard
    ref="target"
    title="Top Event Referrals"
    :is-loading="isLoading"
    :timestamp="allData ? allData.timestamp : null"
    :padding-bottom="false"
  >
    <ReferralsTable
      type="events"
      :is-loading="isLoading"
      :data="data"
      :all-data="allData"
    />
  </ChartCard>
</template>

<script>
import ChartCard from './chart-card';
import { ReferralsTable } from '../charts';

export default {
  components: {
    ChartCard,
    ReferralsTable,
  },

  props: {
    allData: {
      type: Object,
      default: null,
    },

    data: {
      type: Array,
      default: null,
    },

    isLoading: Boolean,
  },
};
</script>

<style lang="scss" scoped></style>
